import MultiColumnLayout from "src/components/Shared/MultiColumnLayout/MultiColumnLayout";
import useGetListAndSelectItem from "src/hooks/useGetListAndSelectItem";
import { PlusIcon } from "@heroicons/react/24/outline";
import ClientAddModal from "../Modal/ClientAddModal";
import ClientBodyContent from "./BodyContent/ClientBodyContent";
import Search from "src/components/Shared/Search";
import Modal from "src/components/Shared/Modal";
import { apiRequest } from "src/async/apiUtils";
import ClientItems from "./ClientItems";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import SelectMenu from "src/components/Shared/Forms/Selects/SelectMenu";
import ButtonDropdown from "src/components/Shared/Buttons/ButtonDropdown";
import Input from "src/components/Shared/Forms/Inputs/Input";
import SlideOver from "src/components/Shared/SlideOver";
import Button from "src/components/Shared/Buttons/Button";
import useFetch from "src/hooks/useFetch";
import { clientTypes } from "src/helpers/clientHelper";
import { ArrowUpRightIcon, EnvelopeIcon, ArrowPathIcon, TrashIcon, NoSymbolIcon, CheckCircleIcon } from "@heroicons/react/24/solid";

const ClientsList = () => {
  const statuses = {
    pending: {
      text: "Pending",
      class: "border-gray-500 bg-gray-50 text-gray-500",
    },
    in_progress: {
      text: "In progress",
      class: "border-amber-500 bg-amber-50 text-amber-500",
    },
    completed: {
      text: "Completed",
      class: "border-green-500 bg-green-50 text-green-500",
    },
    failed: {
      text: "Failed",
      class: "border-red-500 bg-red-50 text-red-500",
    },
    active: {
      text: "Active",
      class: "border-green-500 bg-green-50 text-green-500",
    },
    inactive: {
      text: "In-active",
      class: "border-red-500 bg-red-50 text-red-500",
    },
  };
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [deactiveModalIsOpen, setDeactiveModalIsOpen] = useState(false);
  const [addModalIsOpen, setAddModalIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [clientTypeFilter, setClientTypeFilter] = useState(null);
  const [isExistingClient, setIsExistingClient] = useState(false);

  const [welcomeMailModal, setWelcomeMailModal] = useState(false);
  const [sendingMail, setSendingMail] = useState(false);

  const [syncDbModalIsOpen, setSyncDbModalIsOpen] = useState(false);
  const [isSyncingDb, setIsSyncingDb] = useState(false);
  const [syncDatabaseUrl, setSyncDatabaseUrl] = useState("");

  const { lists, setLists, meta, isLoaded, limit, offset, setOffset, keyword, setKeyword, selectedItem, setSelectedItem, handleOnPaginationChange, refreshData } = useGetListAndSelectItem({
    url: `/clients`,
    paginationData: { limit: 10, offset: 0 },
    additionalQuery: { client_type: clientTypeFilter },
  });

  const {
    response: { data: digitaloceanDomains },
  } = useFetch(`/digitalocean/domains`);

  const handleOnDeleteModalOpen = () => setDeleteModalIsOpen(true);
  const handleOnDeactiveModalOpen = () => setDeactiveModalIsOpen(true);
  const handleSendMailModalOpen = () => setWelcomeMailModal(true);

  const handleTypeChange = async (body) => {
    try {
      setIsEditing(true);
      const response = await apiRequest("PUT", `/clients/:client_id/type`, { params: { client_id: selectedItem?._id }, body: { ...body } });
      toast.success(response?.data?.message);
      setLists((pre) => pre.map((item) => (item?._id === selectedItem?._id ? { ...item, client_type: body?.client_type } : item)));
      setSelectedItem((pre) => ({ ...pre, client_type: body?.client_type }));
      return "success";
    } catch (error) {
      toast.error(error.message);
      return "error";
    } finally {
      setIsEditing(false);
    }
  };

  const handleOnDelete = async () => {
    try {
      setIsDeleting(true);
      const { data } = await apiRequest("DELETE", `/clients/:client_id`, { params: { client_id: selectedItem?._id } });
      setDeleteModalIsOpen(false);
      refreshData();
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsDeleting(false);
    }
  };
  const handleOnDeActive = async (status) => {
    try {
      setIsEditing(true);
      const targetStatus = typeof status === "string" ? status : selectedItem?.status === "active" ? "inactive" : "active";
      const { data } = await apiRequest("PUT", `/clients/:client_id/status`, { params: { client_id: selectedItem?._id }, body: { status: targetStatus } });
      setLists((pre) => pre.map((item) => (item?._id === selectedItem?._id ? { ...item, status: targetStatus } : item)));
      setSelectedItem((pre) => ({ ...pre, status: targetStatus }));
      setDeactiveModalIsOpen(false);
      refreshData();
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsEditing(false);
    }
  };

  const handleOnSwitchToClient = async () => {
    try {
      const { data } = await apiRequest("POST", `/clients/:client_id/token`, { params: { client_id: selectedItem?._id } });
      window.open(data?.data?.url, "_blank");
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleOnSyncDatabase = async () => {
    try {
      setIsSyncingDb(true);
      const { data } = await apiRequest("POST", `/clients/:client_id/sync-database`, { params: { client_id: selectedItem?._id }, body: { database_url: syncDatabaseUrl } });
      setSyncDbModalIsOpen(false);
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSyncingDb(false);
    }
  };

  const handleOnResendWelcomeEmail = async () => {
    try {
      setSendingMail(true);
      const { data } = await apiRequest("POST", `/clients/:client_id/emails/:template/send`, { params: { client_id: selectedItem?._id, template: "welcome-email" } });
      setWelcomeMailModal(false);
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSendingMail(false);
    }
  };

  const headerActions = [
    { name: "Log In To Client", onClick: handleOnSwitchToClient, hasIcon: true, icon: ArrowUpRightIcon, position: "left" },
    { name: "", type: "hr" },
    { name: "Resend welcome email", onClick: handleSendMailModalOpen, hasIcon: true, icon: EnvelopeIcon, position: "left" },
    { name: "", type: "hr" },
    {
      name: "Sync Database",
      onClick: () => {
        setSyncDatabaseUrl("");
        setSyncDbModalIsOpen(true);
      },
      hasIcon: true,
      icon: ArrowPathIcon,
      position: "left",
    },

    { name: "", type: "hr" },
    {
      name: selectedItem?.status === "active" ? "Deactivate" : "Activate",
      onClick: handleOnDeactiveModalOpen,
      hasIcon: true,
      icon: selectedItem?.status === "active" ? NoSymbolIcon : CheckCircleIcon,
      position: "left",
      isDanger: selectedItem?.status === "active",
    },
    { name: "", type: "hr" },
    { name: "Delete", onClick: handleOnDeleteModalOpen, hasIcon: true, icon: TrashIcon, position: "left", isDanger: true },
  ];

  const clientTypeOptions = [{ key: "All", value: "" }, ...clientTypes];

  return (
    <>
      <MultiColumnLayout
        title={"Client List"}
        subTitle={`Total of ${meta?.count || 0} clients`}
        asideLoaded={isLoaded}
        aside={lists}
        paginationData={{ meta, limit, offset }}
        handleOnPaginationChange={handleOnPaginationChange}
        itemEntry={(item) => (
          <ClientItems
            data={item}
            digitaloceanDomains={digitaloceanDomains}
          />
        )}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        mainHeaderContent={
          <>
            <div className="relative w-36">
              <SelectMenu
                inline
                label={"Client Type"}
                startIndex={Math.max(
                  clientTypeOptions.findIndex((c) => c.value === clientTypeFilter),
                  0,
                )}
                options={clientTypeOptions}
                setOption={(option) => {
                  setClientTypeFilter(option.value);
                  setOffset(0);
                }}
              />
            </div>
            <div className="w-96">
              <Search
                keyword={keyword}
                setKeyword={(val) => {
                  setOffset(0);
                  setKeyword(val);
                }}
                placeholder={"Search"}
                inline={true}
              />
            </div>
            <div className="relative">
              <ButtonDropdown
                version="secondary"
                xPosition="right"
                dropdownOptions={[
                  {
                    title: "Create new client",
                    description: "Add a new client to the list",
                    onClick: () => {
                      setAddModalIsOpen(true);
                      setIsExistingClient(false);
                    },
                  },
                  {
                    title: "Add an existing client",
                    description: "Add an existing client to the  list",
                    onClick: () => {
                      setAddModalIsOpen(true);
                      setIsExistingClient(true);
                    },
                  },
                ]}>
                <PlusIcon className="mr-2 h-4 w-4" />
                Add Client
              </ButtonDropdown>
            </div>
          </>
        }
        bodyHeaderActions={headerActions}
        bodyContent={
          <ClientBodyContent
            data={selectedItem}
            statuses={statuses}
            isEditing={isEditing}
            setLists={setLists}
            handleTypeChange={handleTypeChange}
            digitaloceanDomains={digitaloceanDomains}
          />
        }
      />
      <ClientAddModal
        isOpen={addModalIsOpen}
        isExistingClient={isExistingClient}
        onCancel={() => setAddModalIsOpen(false)}
        onSuccess={() => {
          setAddModalIsOpen(false);
          refreshData();
          setOffset(0);
        }}
      />
      <Modal
        title="Client"
        secondaryTitle="Delete"
        isOpen={deleteModalIsOpen}
        onCancel={() => setDeleteModalIsOpen(false)}
        isLoading={isDeleting}
        onSuccess={handleOnDelete}
        defaultOptions={{
          onSuccessButtonText: "Delete",
        }}>
        <div className="flex flex-col gap-y-1 whitespace-nowrap px-3 py-6 text-gray-600">
          <p className="text-lg">
            Are you sure you want to <span className="px-1 font-semibold text-gray-700">DELETE</span>
            this client?
          </p>
          <div className="text-gray-400">Once you delete this client it's gone for good.</div>
        </div>
      </Modal>

      <Modal
        title="Client"
        secondaryTitle={selectedItem?.status === "active" ? "Deactive" : "Active"}
        isOpen={deactiveModalIsOpen}
        onCancel={() => setDeactiveModalIsOpen(false)}
        isLoading={isEditing}
        onSuccess={handleOnDeActive}
        defaultOptions={{
          onSuccessButtonText: selectedItem?.status === "active" ? "Deactive" : "Active",
        }}>
        <div className="flex flex-col gap-y-1 whitespace-nowrap px-3 py-6 text-gray-600">
          <p className="text-lg">
            Are you sure you want to <span className="px-1 font-semibold text-gray-700">{selectedItem?.status === "active" ? "deactivate" : "activate"}</span>
            this client?
          </p>
        </div>
      </Modal>
      <SlideOver
        isOpen={syncDbModalIsOpen}
        handleClose={() => setSyncDbModalIsOpen(false)}
        title="Client"
        description="Sync Database"
        size="3xl"
        footerComponent={
          <div className="flex w-full justify-end gap-x-3">
            <Button
              version="gray"
              onClick={() => setSyncDbModalIsOpen(false)}
              disabled={isSyncingDb}>
              Cancel
            </Button>
            <Button
              version="primary"
              type="button"
              onClick={handleOnSyncDatabase}
              disabled={isSyncingDb || !syncDatabaseUrl?.trim()}
              loading={isSyncingDb}>
              Sync
            </Button>
          </div>
        }>
        <div className="flex flex-col gap-y-3 text-gray-600">
          <p className="text-lg">
            Sync database for <span className="px-1 font-semibold text-gray-700">{selectedItem?.company_name}</span>?
          </p>
          <div className="text-gray-400">
            This will <span className="font-semibold text-red-500">permanently delete all existing data</span> in this client's database, then clone all data from the source database below. This cannot be undone.
          </div>
          <Input
            inline={true}
            label={"Source Database URL"}
            wrapperClass={"bg-white"}
            placeholder="e.g., mongodb://username:password@host:port/database"
            value={syncDatabaseUrl}
            onChange={(e) => setSyncDatabaseUrl(e.target.value)}
          />
        </div>
      </SlideOver>
      <Modal
        title="Client"
        secondaryTitle="Resend welcome email"
        isOpen={welcomeMailModal}
        onCancel={() => setWelcomeMailModal(false)}
        isLoading={sendingMail}
        onSuccess={handleOnResendWelcomeEmail}
        defaultOptions={{
          onSuccessButtonText: "Send",
        }}>
        <div className="flex flex-col gap-y-1 whitespace-nowrap px-3 py-6 text-gray-600">
          <p className="text-lg">
            Are you sure you want to send welcome mail to <span className="px-1 font-semibold text-gray-700"> {selectedItem?.name}</span>?
          </p>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    site: state.site,
  };
};

export default connect(mapStateToProps, {})(ClientsList);
